// src/client/task-types/theory.js

const {requestDummy, requestBaseTask} = require('./base');

const theoryModules = {
  create() {
    return [
      requestDummy(),
      requestBaseTask(),
      requestDummy(),
      requestDummy(),
      requestDummy()
    ];
  },
  componentNames: [
    'HtmlCssView',
    'HtmlCssRunner',
    'HtmlCssChecker'
  ]
};

module.exports = {
  theoryModules,
};
